import React, { useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import {
    obtenerReporteGeneralPdf,
    obtenerReporteIndividualPdf
} from '../../services/empleado/empleadoReporteService'; // Ajusta la ruta

import { Dialog } from 'primereact/dialog';
import ListaReportesXls from './ListaReportesXls';
import { Toast } from 'primereact/toast';

export default function ListaEmpleados({ employees, goToCreate, goToEdit, deleteEmployee, puedeVer = () => true }) {
    // Permisos por bloque aplicados a las acciones de la lista.
    const puedeCrear = puedeVer('BLOQUE_CREAR_EMPLEADO');
    const puedeEliminar = puedeVer('BLOQUE_ELIMINAR_EMPLEADO');
    const puedeExportar = puedeVer('BLOQUE_EXPORTAR_EMPLEADO');

    const [loadingGeneral, setLoadingGeneral] = useState(false);
    const [loadingIndividual, setLoadingIndividual] = useState(null); // Almacena el ID del empleado cargando.

    const myToast = useRef();

    const employeesPlus = employees.map((item) => ({
        ...item,
        estadoDesc: item.estadoConfigDet?.nombre || 'Sin Estado'
    }));

    // Estado para los filtros (necesario para PrimeReact)
    const [filters, setFilters] = useState({
        empleadoId: { value: null, matchMode: 'contains' },
        nombre: { value: null, matchMode: 'contains' },
        apellido: { value: null, matchMode: 'contains' },
        nroIdentificador: { value: null, matchMode: 'contains' }, // Cambio aquí
        estadoDesc: { value: null, matchMode: 'contains' }
    });

    const [mostrarReporte, setMostrarReporte] = useState(false);

    const downloadGeneralReport = async () => {
        setLoadingGeneral(true); // Activa loader
        try {
            const blob = await obtenerReporteGeneralPdf();
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Reporte_General_Personal.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error al descargar reporte general', error);
        } finally {
            setLoadingGeneral(false); // Desactiva loader pase lo que pase
        }
    };

    // --- FUNCIÓN REPORTE INDIVIDUAL ---
    const downloadIndividualReport = async (id) => {
        setLoadingIndividual(id); // Activa loader solo para esta fila
        try {
            const blob = await obtenerReporteIndividualPdf(id);
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Expediente_Empleado_${id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error al descargar reporte individual', error);
        } finally {
            setLoadingIndividual(null); // Desactiva loader
        }
    };

    // 1. Template para los Botones de Acción (Amarillo y Rojo)
    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex gap-2 justify-content-center">
                {puedeExportar && (
                    <Button
                        icon="pi pi-file-pdf"
                        className="p-button-rounded p-button-info"
                        loading={loadingIndividual === rowData.empleadoId}
                        onClick={() => downloadIndividualReport(rowData.empleadoId)}
                        tooltip="Ver Expediente"
                    />
                )}
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-warning"
                    onClick={() => goToEdit(rowData)}
                    tooltip="Editar"
                />
                {puedeEliminar && (
                    <Button
                        icon="pi pi-trash"
                        className="p-button-rounded p-button-danger"
                        // CAMBIO CLAVE: Llamar a la función del hook
                        onClick={() => deleteEmployee(rowData)}
                        tooltip="Eliminar"
                    />
                )}
            </div>
        );
    };

    // 2. Header de la Tarjeta (Título y Botón Crear)
    const header = (
        <div className="flex justify-content-between align-items-center mb-4">
            <h2 className="m-0 text-900 font-bold">Lista Empleados</h2>
            <div className="flex gap-2">
                {puedeExportar && (
                    <Button
                        label="Exportar Datos"
                        className="p-button-primary border-round-3xl px-4"
                        onClick={() => mostrarDataRep()}
                        icon="pi pi-file-excel"
                    />
                )}
                {puedeExportar && (
                    <Button
                        label="Reporte General"
                        icon="pi pi-file-pdf"
                        className="p-button-success border-round-3xl px-4"
                        loading={loadingGeneral}
                        onClick={downloadGeneralReport}
                    />
                )}
                {puedeCrear && (
                    <Button
                        label="Crear"
                        icon="pi pi-plus"
                        className="p-button-primary border-round-3xl px-4"
                        onClick={goToCreate}
                    />
                )}
            </div>
        </div>
    );

    const funcSalir = () => {
        setMostrarReporte(false);
    };

    const [selectRepo, setSelectRepo] = useState([]);

    const mostrarDataRep = () => {
        if (selectRepo.length === 0) {
            myToast.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Debe Seleccionar algun Empleado para Exportar'
            });
            return;
        }

        setMostrarReporte(true);
    };

    return (
        <Card className="w-full shadow-4" style={{ maxWidth: '1200px' }}>
            <Toast ref={myToast} />
            {header}

            <Dialog
                header="Seleccione los datos para exportar"
                visible={mostrarReporte}
                onHide={() => setMostrarReporte(false)}
            >
                <ListaReportesXls funcSalir={funcSalir} lstEmpleados={selectRepo} />
            </Dialog>

            <DataTable
                value={employeesPlus}
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 25]}
                responsiveLayout="scroll"
                emptyMessage="No se encontraron empleados."
                showGridlines
                // Propiedades clave para el filtrado tipo Excel/Mockup
                filterDisplay="row"
                filters={filters}
                onFilter={(e) => setFilters(e.filters)}
                size="small"
                showFilterMenu={false}
                selection={selectRepo}
                onSelectionChange={(evt) => setSelectRepo(evt.value)}
                dataKey="empleadoId"
            >
                {puedeExportar && (
                    <Column
                        selectionMode="multiple"
                        headerStyle={{ width: '3rem' }}
                        exportable={false}
                    ></Column>
                )}

                {/* Columna ID con buscador */}
                <Column
                    field="empleadoId"
                    header="ID"
                    filter
                    showFilterMenu={false}
                    filterPlaceholder="Buscar"
                />

                {/*nro_documento del empleado */}
                <Column
                    field="nroIdentificador"
                    header="Nro Documento"
                    filter
                    showFilterMenu={false}
                    filterPlaceholder="Buscar"
                />

                {/* Columna Nombre con buscador */}
                <Column
                    field="nombre"
                    header="Nombre"
                    filter
                    showFilterMenu={false}
                    filterPlaceholder="Buscar"
                />

                {/* Columna Apellido con buscador */}
                <Column
                    field="apellido"
                    header="Apellido"
                    filter
                    showFilterMenu={false}
                    filterPlaceholder="Buscar"
                />

                <Column
                    field="estadoDesc"
                    header="Estado"
                    filter
                    showFilterMenu={false}
                    filterPlaceholder="Buscar"
                />

                {/* Columna Acciones */}
                <Column
                    header="Acciones"
                    body={actionBodyTemplate}
                    style={{ width: '150px', textAlign: 'center' }}
                />
            </DataTable>
        </Card>
    );
}
